import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Menu from 'controls/menu/Menu';
import Toolbar from 'components/tracks-table/toolbar/Toolbar';
import Table from 'components/tracks-table/table/Table';

export default function TracksTable (props) {
  return (
    <div>
      <Menu/>
      <Toolbar viewType='table' />
      <Table/>
    </div>
  );
}
